import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef,
  AfterContentChecked,
  AfterContentInit,
  AfterViewInit,
  Injector,
  TemplateRef,
} from "@angular/core";
import {
  MatDialog as MatDialog,
  MatDialogConfig as MatDialogConfig,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ModuleService } from "src/app/services/module.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { MediaDialogComponent } from "src/app/new-media/new-media-manager/media-dialog/media-dialog.component";
import { AceConfigInterface } from "ngx-ace-wrapper";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
// import { MediaDialogComponent } from 'src/app/media/media-dialog/media-dialog.component';
import "brace";
import "brace/mode/javascript";
import "brace/mode/css";
import "brace/theme/eclipse";
import { AuthService } from "src/app/services/auth.service";
declare const $: any;

@Component({
  selector: "app-block-settings",
  templateUrl: "./block-settings.component.html",
  styleUrls: ["./block-settings.component.css"],
})
export class BlockSettingsComponent implements OnInit, AfterContentChecked {
  @ViewChild("content", { read: ViewContainerRef, static: true })
  content: ViewContainerRef;

  selectedBlock: any = { element: {} };
  settings: any = {};
  viewGallery: boolean;
  blockType: any;
  modalRef: BsModalRef | null;
  closeGallery: boolean = true;
  videoType: boolean;
  blockIndex: any = 0;
  setCssJsTo: any;

  allClasses: any[] = [];
  colors: any[] = [];
  fonts: any[] = [];
  theme: any = {};

  constructor(
    private moduleService: ModuleService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<BlockSettingsComponent>,
    public dialog: MatDialog,
    private injector: Injector,
    private authService: AuthService,
    private modalService: BsModalService,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.selectedBlock = data.block as any;
    this.blockType = data.type;
    this.blockIndex = data.index;
    this.setCssJsTo = data.from;
    this.theme = data.theme;
  }
  public configJS: AceConfigInterface = {
    mode: "javascript",
    theme: "eclipse",
    readOnly: false,
  };

  ngOnInit() {
    console.log("selected data", this.selectedBlock);

    this.defaultSettings();
    this.getTheme();
    this.selectedBlock.published = this.selectedBlock.published || false;
  }

  defaultSettings() {
    this.selectedBlock.sizes = this.selectedBlock.sizes || {};
    this.selectedBlock.type = this.selectedBlock.type || "full";
    this.selectedBlock.height = this.selectedBlock.height || "default";
    // this.selectedBlock.imgAlign = this.selectedBlock.imgAlign || 'none'
    // this.selectedBlock.backgroundType = this.selectedBlock.backgroundType || 'image'
    // this.selectedBlock.repeatImage = this.selectedBlock.repeatImage || 'no-repeat'
    // this.selectedBlock.positionImage = this.selectedBlock.positionImage || 'center'
    // this.selectedBlock.sizeImage = this.selectedBlock.sizeImage || 'cover'
    // this.selectedBlock.marginTop = this.selectedBlock.marginTop || 0
    // this.selectedBlock.marginRight = this.selectedBlock.marginRight || 0
    // this.selectedBlock.marginBottom = this.selectedBlock.marginBottom || 0
    // this.selectedBlock.marginLeft = this.selectedBlock.marginLeft || 0
    // this.selectedBlock.paddingTop = this.selectedBlock.paddingTop || 0
    // this.selectedBlock.paddingRight = this.selectedBlock.paddingRight || 0
    // this.selectedBlock.paddingBottom = this.selectedBlock.paddingBottom || 0
    // this.selectedBlock.paddingLeft = this.selectedBlock.paddingLeft || 0
    // this.selectedBlock.borderTop = this.selectedBlock.borderTop || 0
    // this.selectedBlock.borderRight = this.selectedBlock.borderRight || 0
    // this.selectedBlock.borderBottom = this.selectedBlock.borderBottom || 0
    // this.selectedBlock.borderLeft = this.selectedBlock.borderLeft || 0
    // this.selectedBlock.borderRadiusTop = this.selectedBlock.borderRadiusTop || 0
    // this.selectedBlock.borderRadiusRight = this.selectedBlock.borderRadiusRight || 0
    // this.selectedBlock.borderRadiusBottom = this.selectedBlock.borderRadiusBottom || 0
    // this.selectedBlock.borderRadiusLeft = this.selectedBlock.borderRadiusLeft || 0
    // this.selectedBlock.textWeight = this.selectedBlock.textWeight || 'default'
    // this.selectedBlock.textTransform = this.selectedBlock.textTransform || 'default'
    // this.selectedBlock.textStyle = this.selectedBlock.textStyle || 'default'
    // this.selectedBlock.textDecoration = this.selectedBlock.textDecoration || 'default'
    // this.selectedBlock.borderType = this.selectedBlock.borderType || 'none'
    this.selectedBlock.blockType =
      this.selectedBlock.blockType || this.blockType;
    this.selectedBlock.blockIndex =
      this.selectedBlock.blockIndex || this.blockIndex;
    this.selectedBlock.setCssJsTo =
      this.selectedBlock.setCssJsTo || this.setCssJsTo;
    this.selectedBlock.CSSInLine =
      this.selectedBlock.CSSInLine || JSON.stringify({});

    // modal/stepper container settings (used by dynamic-site InnerPageComponent)
    this.selectedBlock.showAsModal = this.selectedBlock.showAsModal ?? false;
    this.selectedBlock.modalName = this.selectedBlock.modalName ?? "";
    this.selectedBlock.title =
      this.selectedBlock.title ?? this.selectedBlock.modalName ?? "";
    this.selectedBlock.ModalClassName = this.selectedBlock.ModalClassName ?? "";
    this.selectedBlock.useAsStep = this.selectedBlock.useAsStep ?? false;
    this.selectedBlock.stepKey =
      this.selectedBlock.stepKey ?? this.selectedBlock.modalName ?? "";

    this.selectedBlock.hasCloseButton =
      this.selectedBlock.hasCloseButton ?? true;

    this.selectedBlock.hasUpperCloseButton =
      this.selectedBlock.hasUpperCloseButton ?? true;

    // this.selectedBlock.published = this.selectedBlock.published || false
    // this.selectedBlock.colorFrom = this.selectedBlock.colorFrom || 'static'
    // this.selectedBlock.textColorFrom = this.selectedBlock.textColorFrom || 'static'
    // this.selectedBlock.shadowColorFrom = this.selectedBlock.shadowColorFrom || 'static'
  }

  getTheme() {
    let res = this.theme;
    if (res) {
      for (let i = 0; i < res.length; i++) {
        const element = res[i];
        if (element.isDefault == true) {
          this.allClasses = element.classes ? JSON.parse(element.classes) : [];
          this.colors = element.colors ? JSON.parse(element.colors) : [];
          this.fonts = element.fonts ? JSON.parse(element.fonts) : [];
        }
      }
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  openGallery() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: "0px", right: "0px" };
    dialogConfig.height = "100vh";
    dialogConfig.width = "50vw";
    dialogConfig.panelClass = "media-modal";
    dialogConfig.data = {
      isMultiSelect: false,
      files: ["image", "videos", ".webp"],
    };

    let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      let url = Object.keys(result);
      for (const [key, value] of result.entries()) {
        console.log(value);
        this.selectedBlock.backGroundUrl = value.publicUrl; // nassar
      }
    });
  }
  // openGallery(isMultiSelect: boolean, fg: FormGroup, index) {
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.position = { top: "0px", right: "0px" };
  //   dialogConfig.height = "100vh";
  //   dialogConfig.width = "50vw";
  //   dialogConfig.panelClass = "media-modal";
  //   dialogConfig.data = { isMultiSelect: isMultiSelect, files: ["image"] };

  //   let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       if (isMultiSelect) {
  //         this.mediaImages = result;
  //         fg.setControl("mediaURLs", this.settArrayControls(this.mediaImages, index , ));
  //       }
  //       else {
  //         fg.patchValue({ 'thumbnailId': result.id, 'thumbnailURL': result.publicUrl });
  //       }
  //     }
  //   });
  // }
  // openGallery() {
  //   $("body").removeClass("kt-quick-panel--right kt-subheader--fixed")
  //   var x = this.moduleService.ComponentFactory['GalleryComponent'];
  //   if (this.moduleService.ComponentFactory['GalleryComponent']) {
  //     this.closeGallery = false
  //     this.content.clear();
  //     const component: any = this.content.createComponent(x);
  //     component.instance.data = { enviroment: window['config'] };
  //     component.instance.imgUrl.subscribe(res => {
  //       if (res && res != null) {
  //         if (res.contentType.indexOf('video/') != -1) {
  //           this.selectedBlock.videoType = true
  //         }
  //         if (res.contentType.indexOf('image/') != -1) {
  //           this.selectedBlock.videoType = false
  //         }
  //         this.selectedBlock.backGroundUrl = '/' + res.publicUrl
  //         while (this.selectedBlock.backGroundUrl.indexOf('\\') !== -1) {
  //           this.selectedBlock.backGroundUrl = this.selectedBlock.backGroundUrl.replace('\\', '/');
  //         }

  //       }
  //       this.closeGallery = true;
  //       $("body").addClass("kt-quick-panel--right kt-subheader--fixed")
  //       this.content.clear();
  //     });
  //   }

  // }

  getThumbnailUrl(url) {
    return window["config"].apiUrl + "/" + url;
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  loadActionsComp = async (vcr: ViewContainerRef) => {
    if (!vcr) {
      console.warn("content2Ref still undefined");
      return;
    }

    vcr.clear();

    const key = "ActionsModalComponent";
    const componentType = this.moduleService.ComponentFactory[key];

    if (!componentType) return;

    const componentRef: any = vcr.createComponent(componentType, {
      injector: this.injector,
    });

    const componentData = this.selectedBlock || {};

    componentRef.instance.parentObj = componentRef.instance.parentObj || {
      actionList: [],
    };

    componentRef.instance.data = {
      page: {},
      component: componentData,
      moduleService: this.moduleService,
      authService: this.authService,
      ComponentFactory: this.moduleService.ComponentFactory,
      enviroment: "",
      dayGridPlugin,
      interactionPlugin,
    };

    componentRef.instance.parentObj = componentData;
    componentRef.instance.isChild = true;

    componentRef.changeDetectorRef.detectChanges();
  };

  openActionsModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-xl modal-dialog-centered",
    });
  }
}
